import { useEffect, useRef } from "react";
import { useSocket } from "../../../context/SocketContext";

export const useDeviceSocket = ({ workforceUid, companyId, onDisconnect, onLink, onRecord }) => {
  const { socket } = useSocket() || {};
  const onDisconnectRef = useRef(onDisconnect);
  const onLinkRef = useRef(onLink);
  const onRecordRef = useRef(onRecord);
  onDisconnectRef.current = onDisconnect;
  onLinkRef.current = onLink;
  onRecordRef.current = onRecord;

  useEffect(() => {
    if (!socket || !workforceUid || !companyId) return;

    const room = `room_company_${companyId}_workforce_${workforceUid}`;

    const join = () => {
      socket.emit("join", [room]);
    };

    if (socket.connected) join();
    socket.on("connect", join);

    const handleDisconnectDevice = () => {
      onDisconnectRef.current?.();
    };

    const handleLinkDevice = (payload) => {
      try {
        const linkedDevice = typeof payload === "string" ? JSON.parse(payload) : payload;
        onLinkRef.current?.(linkedDevice);
      } catch (error) {
        console.error("Error parsing linked device payload:", error);
      }
    };

    const handleDeviceRecord = (record) => {
      onRecordRef.current?.(record);
    };

    socket.on("deviceTracker:unlink", handleDisconnectDevice);
    socket.on("deviceTracker:link", handleLinkDevice);
    socket.on("deviceTrackerMessage", handleDeviceRecord);

    return () => {
      socket.off("connect", join);
      socket.off("deviceTracker:unlink", handleDisconnectDevice);
      socket.off("deviceTracker:link", handleLinkDevice);
      socket.off("deviceTrackerMessage", handleDeviceRecord);
    };
  }, [socket, workforceUid, companyId]);
};

/** While a code is on screen, keep asking until the phone finishes pairing. */
export const useRefreshUntilLinked = (workforceUid, status, refresh) => {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!workforceUid || !status || status === "linked") return;

    const timer = setInterval(() => {
      refreshRef.current?.();
    }, 2500);

    return () => clearInterval(timer);
  }, [workforceUid, status]);
};
